import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import AdvancedList_Bulk_SelectAll from "../AdvancedList/AdvancedList_Bulk_SelectAll";
import {bookingListSet} from "../../store/actions/bookingList";

const BookingList_SortHeaders = ({_requestSort, _getClassNamesFor}) => {
    const dispatch = useDispatch();
    const selectedHospital = useSelector(state => state.auth.selectedHospital);
    const {keyword, status, page, filter, sortColumn, sortMode} = useSelector(state => state.bookingList);

    // const requestSort = (column) => {
    //     let newSortMode = "asc";
    //     if (sortColumn === column && sortMode === "asc") {
    //         newSortMode = "desc";
    //     }
    //     dispatch(bookingListSet(selectedHospital.id, status, keyword, filter, page, column, newSortMode));
    // };
    //
    // const getClassNamesFor = (column) => {
    //     if (sortColumn !== column) return "sorting";
    //     return sortMode === "asc" ? "sorting_asc" : "sorting_desc";
    // };

    const requestSort = (_param, defaultAsc) => {
        return _requestSort(_param, defaultAsc)
    }
    const getClassNamesFor = _param => {
        return _getClassNamesFor(_param)
    }

    return (
        <thead>
            <tr>
                <th className={getClassNamesFor('surgeon')} onClick={() => requestSort('surgeon')}><strong className="title">Surgeon Name</strong></th>
                <th className="no-sort"><strong className="title">Source</strong></th>
                <th className="no-sort"><strong className="title">UID</strong></th>
                <th className="no-sort"><strong className="title">Patient First Name</strong></th>
                <th className="no-sort"><strong className="title">Patient Surname</strong></th>
                <th className="no-sort"><strong className="title">Patient Mobile</strong></th>
                <th className="no-sort"><strong className="title">Patient DOB</strong></th>
                <th className={getClassNamesFor('procedureDate')} onClick={() => requestSort('procedureDate')}><strong className="title">Procedure Date</strong></th>
                <th className="no-sort"><strong className="title">Procedure Reason</strong></th>
                <th className="no-sort"><strong className="title">Created At</strong></th>
                <th className="no-sort"><strong className="title">Booking Files</strong></th>
                {selectedHospital.booking_preAdmission && (
                    <th className="no-sort"><strong className="title">{selectedHospital.booking_preAdmission.columnTitle || 'PA'}</strong></th>
                )}
                {selectedHospital.booking_sendSms_enable && (
                    <th className="no-sort"><strong className="title">Message</strong></th>
                )}
                <th className="no-sort"></th>
            </tr>
        </thead>
    );

}

export default BookingList_SortHeaders;